export default class ProjectsManager {
    constructor() {
        this.currentProjectIndex = 0;
        this.openDrawer = null; // Track which drawer is open

        // Define project data with images
        this.projectsData = [
            {
                id: 'uxma-bossel',
                title: 'UXMA BOSSEL-APP',
                drawerImages: [
                    '/images/project01/bosselLanding.webp',
                    '/images/project01/bosselMain.webp',
                    '/images/project01/bosselEditTeam.webp',
                    '/images/project01/bosselOverview.webp',
                    '/images/project01/bosselScan.webp',
                    '/images/project01/bosselWait.webp'
                ],
                allImages: [
                    '/images/project01/bosselLanding.webp',
                    '/images/project01/bosselMain.webp',
                    '/images/project01/bosselEditTeam.webp',
                    '/images/project01/bosselOverview.webp',
                    '/images/project01/bosselScan.webp',
                    '/images/project01/bosselWait.webp',
                    '/images/project01/bosselWeb1.webp',
                    '/images/project01/bosselWeb2.webp',
                    '/images/project01/bosselWeb3.webp',
                    '/images/project01/bosselWeb4.webp'
                ]
            },
            {
                id: 'mathazars-dungeon',
                title: "MATHAZAR'S DUNGEON",
                drawerImages: [
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room0clip1.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room0clip2.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room1clip1.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room3clip1.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room4clip1.mp4'
                ],
                allImages: [
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room0clip1.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room0clip2.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room1clip1.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room3clip1.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room4clip1.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room0clip3.mp4',
                    'https://5gqrasqit1jp15yl.public.blob.vercel-storage.com/mathazar/room2clip1.mp4'
                ]
            },
            {
                id: 'webpilot',
                title: 'WEBPILOT',
                drawerImages: [
                    '/images/project03/webpilotStore.webp',
                    '/images/project03/webpilotLevels.webp',
                    '/images/project03/webpilotExample.webp',
                    '/images/project03/webpilotExample2.webp',
                    '/images/project03/webpilotWarning.webp'
                ],
                allImages: [
                    '/images/project03/webpilotStore.webp',
                    '/images/project03/webpilotLevels.webp',
                    '/images/project03/webpilotExample.webp',
                    '/images/project03/webpilotExample2.webp',
                    '/images/project03/webpilotWarning.webp',
                    '/images/project03/webpilotDownload.webp',
                    '/images/project03/webpilotInstructions.webp'
                ]
            },
            {
                id: 'deadwood-music',
                title: 'DEADWOOD.MUSIC',
                drawerImages: [
                    '/images/project04/deadwoodLanding.webp',
                    '/images/project04/deadwoodRoster.webp'
                ]
            },
            {
                id: 'tomunger-portfolio',
                title: 'TOMUNGER.DEV',
                drawerImages: []
            }
        ];

        this.initializeElements();
        this.bindEvents();
        this.createImageOverlay();
    }

    initializeElements() {
        this.projectItems = document.querySelectorAll('.project-item');
        this.projectDrawers = document.querySelectorAll('.project-drawer');
    }

    bindEvents() {
        // Add click events to project items
        this.projectItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                this.handleProjectClick(index);
            });
        });
    }

    handleProjectClick(projectIndex) {
        // If clicking the same project, toggle the drawer
        if (projectIndex === this.currentProjectIndex && this.openDrawer === projectIndex) {
            this.closeDrawer(projectIndex);
            return;
        }

        // Close currently open drawer if any
        if (this.openDrawer !== null && this.openDrawer !== projectIndex) {
            this.closeDrawer(this.openDrawer);
            // Wait for fast closing animation to complete before opening new drawer
            setTimeout(() => {
                this.selectProject(projectIndex);
                this.openProjectDrawer(projectIndex);
            }, 250); // Wait for fast closing animation
            return;
        }

        // Select the project and open its drawer
        this.selectProject(projectIndex);
        this.openProjectDrawer(projectIndex);
    }

    selectProject(projectIndex) {
        this.currentProjectIndex = projectIndex;

        // Update active state for project items
        this.updateProjectActiveState(projectIndex);
    }

    openProjectDrawer(projectIndex) {
        const drawer = this.projectDrawers[projectIndex];
        if (drawer) {
            // Load images before opening the drawer
            this.loadProjectImages(projectIndex);

            drawer.classList.add('open');
            this.openDrawer = projectIndex;

            // Refresh ScrollTrigger after drawer opens to recalculate positions
            this.refreshScrollTriggerAfterDelay();
        }
    }

    loadProjectImages(projectIndex) {
        const project = this.projectsData[projectIndex];
        const drawer = this.projectDrawers[projectIndex];

        if (!project || !drawer) return;

        const imagesContainer = drawer.querySelector('.project-images');
        if (!imagesContainer) return;

        // Clear existing images
        imagesContainer.innerHTML = '';

        // Add project images/videos with zoom functionality
        project.drawerImages.forEach((mediaSrc, index) => {
            // Create container for media with hover effects
            const imageContainer = document.createElement('div');
            imageContainer.className = 'image-container';

            // Determine if this is a video or image
            const isVideo = mediaSrc.endsWith('.mp4') || mediaSrc.endsWith('.webm') || mediaSrc.endsWith('.mov');

            let mediaElement;
            if (isVideo) {
                mediaElement = document.createElement('video');
                // Set src immediately but with minimal preload for thumbnail
                mediaElement.src = mediaSrc;
                mediaElement.muted = true;
                mediaElement.loop = true;
                mediaElement.playsInline = true;
                mediaElement.preload = 'metadata'; // Load just enough to show first frame
                mediaElement.loading = 'lazy';

                let hasPlayed = false;

                // Play video on hover
                imageContainer.addEventListener('mouseenter', () => {
                    mediaElement.currentTime = 0; // Reset to beginning
                    mediaElement.play().catch(e => console.log('Video play failed:', e));
                    hasPlayed = true;
                });

                imageContainer.addEventListener('mouseleave', () => {
                    mediaElement.pause();
                    mediaElement.currentTime = 0; // Reset to show first frame
                });
            } else {
                mediaElement = document.createElement('img');
                mediaElement.src = mediaSrc;
                mediaElement.loading = 'lazy';
            }

            mediaElement.alt = `${project.title} - ${isVideo ? 'Video' : 'Image'} ${index + 1}`;

            // Create zoom icon
            const zoomIcon = document.createElement('div');
            zoomIcon.className = 'zoom-icon';
            zoomIcon.innerHTML = `
                <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path xmlns="http://www.w3.org/2000/svg" d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.551 16.3199 14.9056L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9056 16.3199C13.551 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10Z" fill="currentColor"></path>
                </svg>
            `;

            // Check if this is the last image in the drawer array
            const isLastImage = index === project.drawerImages.length - 1;
            const hasAllImages = project.allImages && project.allImages.length > 0;
            const remainingImages = hasAllImages ? project.allImages.length - project.drawerImages.length : 0;

            // If it's the last image and there are additional images in allImages, add "view more" overlay
            if (isLastImage && hasAllImages && remainingImages > 0) {
                imageContainer.classList.add('last-image');

                // Create "view more" overlay
                const viewMoreOverlay = document.createElement('div');
                viewMoreOverlay.className = 'view-more-overlay';
                viewMoreOverlay.innerHTML = `
                    <div class="view-more-content">
                        <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path xmlns="http://www.w3.org/2000/svg" d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z" fill="currentColor"></path>
                        </svg>
                        <span class="remaining-count">${remainingImages}</span>
                    </div>
                `;
                imageContainer.appendChild(viewMoreOverlay);
            }

            // Add click event to open overlay (using allImages for navigation)
            imageContainer.addEventListener('click', (event) => {
                event.stopPropagation(); // Prevent event bubbling
                this.openImageOverlay(projectIndex, index);
            });

            imageContainer.appendChild(mediaElement);
            imageContainer.appendChild(zoomIcon);
            imagesContainer.appendChild(imageContainer);
        });

        // Prevent drawer closing when clicking links
        this.setupLinkEventListeners(drawer);
    }

    setupLinkEventListeners(drawer) {
        // Find all links in the drawer and prevent event bubbling
        const links = drawer.querySelectorAll('a[href^="https://www.linkedin.com"]');
        links.forEach(link => {
            link.addEventListener('click', (event) => {
                event.stopPropagation(); // Prevent the drawer from closing
            });
        });
    }

    createImageOverlay() {
        // Create overlay element
        this.imageOverlay = document.createElement('div');
        this.imageOverlay.className = 'image-overlay';

        // Create container for media (will hold either img or video)
        this.overlayMediaContainer = document.createElement('div');
        this.overlayMediaContainer.className = 'overlay-media-container';

        // Create overlay image (default)
        this.overlayImage = document.createElement('img');

        // Create overlay video (will be used when needed)
        this.overlayVideo = document.createElement('video');
        this.overlayVideo.controls = true;
        this.overlayVideo.muted = false;
        this.overlayVideo.loop = true;
        this.overlayVideo.playsInline = true;
        this.overlayVideo.style.display = 'none';

        this.overlayMediaContainer.appendChild(this.overlayImage);
        this.overlayMediaContainer.appendChild(this.overlayVideo);

        // Create close button
        const closeButton = document.createElement('button');
        closeButton.className = 'image-overlay-close';
        closeButton.innerHTML = `
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path xmlns="http://www.w3.org/2000/svg" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="white"></path>
            </svg>
        `;
        closeButton.addEventListener('click', () => this.closeImageOverlay());

        // Create image counter
        this.imageCounter = document.createElement('div');
        this.imageCounter.className = 'image-overlay-counter';

        // Create audio toggle button (only for videos)
        this.audioToggleButton = document.createElement('button');
        this.audioToggleButton.className = 'image-overlay-audio-toggle';
        this.audioToggleButton.style.display = 'none'; // Hidden by default
        this.isAudioEnabled = true; // Audio on by default

        // Set initial audio on icon
        this.audioToggleButton.innerHTML = `
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path xmlns="http://www.w3.org/2000/svg" d="M13.4179 2.0915C13.7727 2.25469 14 2.60948 14 3.00001V21C14 21.3905 13.7727 21.7453 13.4179 21.9085C13.0631 22.0717 12.6457 22.0134 12.3492 21.7593L5.63008 16H3C2.44772 16 2 15.5523 2 15V9.00001C2 8.44773 2.44772 8.00001 3 8.00001H5.63008L12.3492 2.24076C12.6457 1.9866 13.0631 1.92832 13.4179 2.0915ZM12 5.17423L6.65079 9.75927C6.46955 9.91462 6.23871 10 6 10H4V14H6C6.23871 14 6.46955 14.0854 6.65079 14.2408L12 18.8258V5.17423ZM17.2929 5.29291C17.6834 4.90238 18.3166 4.90238 18.7071 5.29291L18.7078 5.29362L18.7086 5.29438L18.7102 5.29605L18.7141 5.29996L18.724 5.31008C18.7315 5.31784 18.7409 5.32765 18.752 5.33951C18.7742 5.36322 18.8034 5.39513 18.8385 5.43526C18.9087 5.51549 19.0028 5.62871 19.1125 5.77501C19.3318 6.06748 19.6147 6.49329 19.8944 7.0528C20.4556 8.17509 21 9.82725 21 12C21 14.1728 20.4556 15.8249 19.8944 16.9472C19.6147 17.5067 19.3318 17.9326 19.1125 18.225C19.0028 18.3713 18.9087 18.4845 18.8385 18.5648C18.8034 18.6049 18.7742 18.6368 18.752 18.6605C18.7409 18.6724 18.7315 18.6822 18.724 18.69L18.7141 18.7001L18.7102 18.704L18.7086 18.7056L18.7078 18.7064L18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071C16.904 18.3183 16.9024 17.6889 17.2879 17.2979L17.2929 17.2926C17.3 17.2851 17.3138 17.2701 17.3334 17.2478C17.3725 17.203 17.4347 17.1287 17.5125 17.025C17.6682 16.8175 17.8853 16.4933 18.1056 16.0528C18.5444 15.1751 19 13.8272 19 12C19 10.1728 18.5444 8.82494 18.1056 7.94723C17.8853 7.50674 17.6682 7.18255 17.5125 6.97501C17.4347 6.87131 17.3725 6.79704 17.3334 6.75227C17.3138 6.72989 17.3 6.71493 17.2929 6.70739L17.2879 6.70208C16.9024 6.31117 16.904 5.68176 17.2929 5.29291ZM15.2929 8.29291C15.6834 7.90238 16.3166 7.90238 16.7071 8.29291L16.7085 8.29434L16.7101 8.29587L16.7134 8.29923L16.7211 8.30715L16.7408 8.32779C16.7557 8.34369 16.7741 8.36388 16.7955 8.38838C16.8384 8.43736 16.8934 8.50371 16.9563 8.58751C17.0818 8.75498 17.2397 8.99329 17.3944 9.3028C17.7056 9.92509 18 10.8273 18 12C18 13.1728 17.7056 14.0749 17.3944 14.6972C17.2397 15.0067 17.0818 15.2451 16.9563 15.4125C16.8934 15.4963 16.8384 15.5627 16.7955 15.6116C16.7741 15.6361 16.7557 15.6563 16.7408 15.6722L16.7211 15.6929L16.7134 15.7008L16.7101 15.7042L16.7085 15.7057L16.7078 15.7064C16.3173 16.0969 15.6834 16.0976 15.2929 15.7071C14.9057 15.32 14.9024 14.6943 15.2829 14.303C15.2843 14.3015 15.2868 14.2987 15.2904 14.2946C15.3022 14.2811 15.3253 14.2537 15.3562 14.2125C15.4182 14.13 15.5103 13.9933 15.6056 13.8028C15.7944 13.4251 16 12.8272 16 12C16 11.1728 15.7944 10.5749 15.6056 10.1972C15.5103 10.0067 15.4182 9.87005 15.3562 9.78751C15.3253 9.74631 15.3022 9.71892 15.2904 9.70539C15.2868 9.70132 15.2843 9.69852 15.2829 9.69701C14.9024 9.30574 14.9057 8.68008 15.2929 8.29291Z" fill="white"></path>
            </svg>
        `;

        this.audioToggleButton.addEventListener('click', () => this.toggleAudio());

        // Create navigation buttons
        this.prevButton = document.createElement('button');
        this.prevButton.className = 'image-overlay-nav image-overlay-prev';
        this.prevButton.innerHTML = `
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path xmlns="http://www.w3.org/2000/svg" d="M14.7071 5.29289C15.0976 5.68342 15.0976 6.31658 14.7071 6.70711L9.41421 12L14.7071 17.2929C15.0976 17.6834 15.0976 18.3166 14.7071 18.7071C14.3166 19.0976 13.6834 19.0976 13.2929 18.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289Z" fill="white"></path>
            </svg>
        `;
        this.prevButton.addEventListener('click', () => this.navigateImage(-1));

        this.nextButton = document.createElement('button');
        this.nextButton.className = 'image-overlay-nav image-overlay-next';
        this.nextButton.innerHTML = `
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path xmlns="http://www.w3.org/2000/svg" d="M9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L14.5858 12L9.29289 6.70711C8.90237 6.31658 8.90237 5.68342 9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071Z" fill="white"></path>
            </svg>
        `;
        this.nextButton.addEventListener('click', () => this.navigateImage(1));

        this.imageOverlay.appendChild(this.overlayMediaContainer);
        this.imageOverlay.appendChild(closeButton);
        this.imageOverlay.appendChild(this.imageCounter);
        this.imageOverlay.appendChild(this.audioToggleButton);
        this.imageOverlay.appendChild(this.prevButton);
        this.imageOverlay.appendChild(this.nextButton);
        document.body.appendChild(this.imageOverlay);

        // Close overlay when clicking outside the image
        this.imageOverlay.addEventListener('click', (e) => {
            if (e.target === this.imageOverlay) {
                this.closeImageOverlay();
            }
        });

        // Close overlay with ESC key and add keyboard navigation
        document.addEventListener('keydown', (e) => {
            if (this.imageOverlay.classList.contains('active')) {
                if (e.key === 'Escape') {
                    this.closeImageOverlay();
                } else if (e.key === 'ArrowLeft') {
                    this.navigateImage(-1);
                } else if (e.key === 'ArrowRight') {
                    this.navigateImage(1);
                }
            }
        });
    }

    openImageOverlay(projectIndex, imageIndex) {
        this.currentOverlayProject = projectIndex;
        this.currentOverlayImage = imageIndex;

        const project = this.projectsData[projectIndex];
        const imagesToUse = project.allImages || project.drawerImages;
        const mediaSrc = imagesToUse[imageIndex];

        // Determine if this is a video or image
        const isVideo = mediaSrc.endsWith('.mp4') || mediaSrc.endsWith('.webm') || mediaSrc.endsWith('.mov');
        const isMathazarProject = project.id === 'mathazars-dungeon';

        // Show/hide audio toggle button only for Mathazar project videos
        if (isVideo && isMathazarProject) {
            this.audioToggleButton.style.display = 'block';
            // Reset audio state to enabled when opening
            this.isAudioEnabled = true;
            this.overlayVideo.muted = false;
            // Update button to show audio on icon
            this.audioToggleButton.innerHTML = `
                <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path xmlns="http://www.w3.org/2000/svg" d="M13.4179 2.0915C13.7727 2.25469 14 2.60948 14 3.00001V21C14 21.3905 13.7727 21.7453 13.4179 21.9085C13.0631 22.0717 12.6457 22.0134 12.3492 21.7593L5.63008 16H3C2.44772 16 2 15.5523 2 15V9.00001C2 8.44773 2.44772 8.00001 3 8.00001H5.63008L12.3492 2.24076C12.6457 1.9866 13.0631 1.92832 13.4179 2.0915ZM12 5.17423L6.65079 9.75927C6.46955 9.91462 6.23871 10 6 10H4V14H6C6.23871 14 6.46955 14.0854 6.65079 14.2408L12 18.8258V5.17423ZM17.2929 5.29291C17.6834 4.90238 18.3166 4.90238 18.7071 5.29291L18.7078 5.29362L18.7086 5.29438L18.7102 5.29605L18.7141 5.29996L18.724 5.31008C18.7315 5.31784 18.7409 5.32765 18.752 5.33951C18.7742 5.36322 18.8034 5.39513 18.8385 5.43526C18.9087 5.51549 19.0028 5.62871 19.1125 5.77501C19.3318 6.06748 19.6147 6.49329 19.8944 7.0528C20.4556 8.17509 21 9.82725 21 12C21 14.1728 20.4556 15.8249 19.8944 16.9472C19.6147 17.5067 19.3318 17.9326 19.1125 18.225C19.0028 18.3713 18.9087 18.4845 18.8385 18.5648C18.8034 18.6049 18.7742 18.6368 18.752 18.6605C18.7409 18.6724 18.7315 18.6822 18.724 18.69L18.7141 18.7001L18.7102 18.704L18.7086 18.7056L18.7078 18.7064L18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071C16.904 18.3183 16.9024 17.6889 17.2879 17.2979L17.2929 17.2926C17.3 17.2851 17.3138 17.2701 17.3334 17.2478C17.3725 17.203 17.4347 17.1287 17.5125 17.025C17.6682 16.8175 17.8853 16.4933 18.1056 16.0528C18.5444 15.1751 19 13.8272 19 12C19 10.1728 18.5444 8.82494 18.1056 7.94723C17.8853 7.50674 17.6682 7.18255 17.5125 6.97501C17.4347 6.87131 17.3725 6.79704 17.3334 6.75227C17.3138 6.72989 17.3 6.71493 17.2929 6.70739L17.2879 6.70208C16.9024 6.31117 16.904 5.68176 17.2929 5.29291ZM15.2929 8.29291C15.6834 7.90238 16.3166 7.90238 16.7071 8.29291L16.7085 8.29434L16.7101 8.29587L16.7134 8.29923L16.7211 8.30715L16.7408 8.32779C16.7557 8.34369 16.7741 8.36388 16.7955 8.38838C16.8384 8.43736 16.8934 8.50371 16.9563 8.58751C17.0818 8.75498 17.2397 8.99329 17.3944 9.3028C17.7056 9.92509 18 10.8273 18 12C18 13.1728 17.7056 14.0749 17.3944 14.6972C17.2397 15.0067 17.0818 15.2451 16.9563 15.4125C16.8934 15.4963 16.8384 15.5627 16.7955 15.6116C16.7741 15.6361 16.7557 15.6563 16.7408 15.6722L16.7211 15.6929L16.7134 15.7008L16.7101 15.7042L16.7085 15.7057L16.7078 15.7064C16.3173 16.0969 15.6834 16.0976 15.2929 15.7071C14.9057 15.32 14.9024 14.6943 15.2829 14.303C15.2843 14.3015 15.2868 14.2987 15.2904 14.2946C15.3022 14.2811 15.3253 14.2537 15.3562 14.2125C15.4182 14.13 15.5103 13.9933 15.6056 13.8028C15.7944 13.4251 16 12.8272 16 12C16 11.1728 15.7944 10.5749 15.6056 10.1972C15.5103 10.0067 15.4182 9.87005 15.3562 9.78751C15.3253 9.74631 15.3022 9.71892 15.2904 9.70539C15.2868 9.70132 15.2843 9.69852 15.2829 9.69701C14.9024 9.30574 14.9057 8.68008 15.2929 8.29291Z" fill="white"></path>
                </svg>
            `;
        } else {
            this.audioToggleButton.style.display = 'none';
        }

        if (isVideo) {
            // Hide image, show video
            this.overlayImage.style.display = 'none';
            this.overlayVideo.style.display = 'block';
            this.overlayVideo.src = mediaSrc;
            this.overlayVideo.load(); // Reload the video

            // Auto-play the video
            this.overlayVideo.play().catch(e => console.log('Video autoplay failed:', e));
        } else {
            // Hide video, show image
            this.overlayVideo.style.display = 'none';
            this.overlayImage.style.display = 'block';
            this.overlayImage.src = mediaSrc;
        }

        const altText = `${project.title} - ${isVideo ? 'Video' : 'Image'} ${imageIndex + 1}`;
        this.overlayImage.alt = altText;

        this.imageOverlay.classList.add('active');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling

        this.updateNavigationButtons();
        this.updateImageCounter();
    }

    updateImageCounter() {
        if (!this.imageCounter) return;

        const project = this.projectsData[this.currentOverlayProject];
        const imagesToUse = project.allImages || project.drawerImages;
        const currentNumber = this.currentOverlayImage + 1;
        const totalNumber = imagesToUse.length;

        this.imageCounter.textContent = `${currentNumber} / ${totalNumber}`;
    }

    toggleAudio() {
        if (!this.overlayVideo) return;

        this.isAudioEnabled = !this.isAudioEnabled;
        this.overlayVideo.muted = !this.isAudioEnabled;

        // Update button icon
        if (this.isAudioEnabled) {
            // Audio ON icon
            this.audioToggleButton.innerHTML = `
                <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path xmlns="http://www.w3.org/2000/svg" d="M13.4179 2.0915C13.7727 2.25469 14 2.60948 14 3.00001V21C14 21.3905 13.7727 21.7453 13.4179 21.9085C13.0631 22.0717 12.6457 22.0134 12.3492 21.7593L5.63008 16H3C2.44772 16 2 15.5523 2 15V9.00001C2 8.44773 2.44772 8.00001 3 8.00001H5.63008L12.3492 2.24076C12.6457 1.9866 13.0631 1.92832 13.4179 2.0915ZM12 5.17423L6.65079 9.75927C6.46955 9.91462 6.23871 10 6 10H4V14H6C6.23871 14 6.46955 14.0854 6.65079 14.2408L12 18.8258V5.17423ZM17.2929 5.29291C17.6834 4.90238 18.3166 4.90238 18.7071 5.29291L18.7078 5.29362L18.7086 5.29438L18.7102 5.29605L18.7141 5.29996L18.724 5.31008C18.7315 5.31784 18.7409 5.32765 18.752 5.33951C18.7742 5.36322 18.8034 5.39513 18.8385 5.43526C18.9087 5.51549 19.0028 5.62871 19.1125 5.77501C19.3318 6.06748 19.6147 6.49329 19.8944 7.0528C20.4556 8.17509 21 9.82725 21 12C21 14.1728 20.4556 15.8249 19.8944 16.9472C19.6147 17.5067 19.3318 17.9326 19.1125 18.225C19.0028 18.3713 18.9087 18.4845 18.8385 18.5648C18.8034 18.6049 18.7742 18.6368 18.752 18.6605C18.7409 18.6724 18.7315 18.6822 18.724 18.69L18.7141 18.7001L18.7102 18.704L18.7086 18.7056L18.7078 18.7064L18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071C16.904 18.3183 16.9024 17.6889 17.2879 17.2979L17.2929 17.2926C17.3 17.2851 17.3138 17.2701 17.3334 17.2478C17.3725 17.203 17.4347 17.1287 17.5125 17.025C17.6682 16.8175 17.8853 16.4933 18.1056 16.0528C18.5444 15.1751 19 13.8272 19 12C19 10.1728 18.5444 8.82494 18.1056 7.94723C17.8853 7.50674 17.6682 7.18255 17.5125 6.97501C17.4347 6.87131 17.3725 6.79704 17.3334 6.75227C17.3138 6.72989 17.3 6.71493 17.2929 6.70739L17.2879 6.70208C16.9024 6.31117 16.904 5.68176 17.2929 5.29291ZM15.2929 8.29291C15.6834 7.90238 16.3166 7.90238 16.7071 8.29291L16.7085 8.29434L16.7101 8.29587L16.7134 8.29923L16.7211 8.30715L16.7408 8.32779C16.7557 8.34369 16.7741 8.36388 16.7955 8.38838C16.8384 8.43736 16.8934 8.50371 16.9563 8.58751C17.0818 8.75498 17.2397 8.99329 17.3944 9.3028C17.7056 9.92509 18 10.8273 18 12C18 13.1728 17.7056 14.0749 17.3944 14.6972C17.2397 15.0067 17.0818 15.2451 16.9563 15.4125C16.8934 15.4963 16.8384 15.5627 16.7955 15.6116C16.7741 15.6361 16.7557 15.6563 16.7408 15.6722L16.7211 15.6929L16.7134 15.7008L16.7101 15.7042L16.7085 15.7057L16.7078 15.7064C16.3173 16.0969 15.6834 16.0976 15.2929 15.7071C14.9057 15.32 14.9024 14.6943 15.2829 14.303C15.2843 14.3015 15.2868 14.2987 15.2904 14.2946C15.3022 14.2811 15.3253 14.2537 15.3562 14.2125C15.4182 14.13 15.5103 13.9933 15.6056 13.8028C15.7944 13.4251 16 12.8272 16 12C16 11.1728 15.7944 10.5749 15.6056 10.1972C15.5103 10.0067 15.4182 9.87005 15.3562 9.78751C15.3253 9.74631 15.3022 9.71892 15.2904 9.70539C15.2868 9.70132 15.2843 9.69852 15.2829 9.69701C14.9024 9.30574 14.9057 8.68008 15.2929 8.29291Z" fill="white"></path>
                </svg>
            `;
        } else {
            // Audio OFF icon
            this.audioToggleButton.innerHTML = `
                <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path xmlns="http://www.w3.org/2000/svg" d="M13.4179 2.0915C13.7727 2.25469 14 2.60948 14 3.00001V21C14 21.3905 13.7727 21.7453 13.4179 21.9085C13.0631 22.0717 12.6457 22.0134 12.3492 21.7593L5.63008 16H3C2.44772 16 2 15.5523 2 15V9.00001C2 8.44773 2.44772 8.00001 3 8.00001H5.63008L12.3492 2.24076C12.6457 1.9866 13.0631 1.92832 13.4179 2.0915ZM12 5.17423L6.65079 9.75927C6.46955 9.91462 6.23871 10 6 10H4V14H6C6.23871 14 6.46955 14.0854 6.65079 14.2408L12 18.8258V5.17423ZM16.2929 9.29291C16.6834 8.90238 17.3166 8.90238 17.7071 9.29291L19 10.5858L20.2929 9.29291C20.6834 8.90238 21.3166 8.90238 21.7071 9.29291C22.0976 9.68343 22.0976 10.3166 21.7071 10.7071L20.4142 12L21.7071 13.2929C22.0976 13.6834 22.0976 14.3166 21.7071 14.7071C21.3166 15.0976 20.6834 15.0976 20.2929 14.7071L19 13.4142L17.7071 14.7071C17.3166 15.0976 16.6834 15.0976 16.2929 14.7071C15.9024 14.3166 15.9024 13.6834 16.2929 13.2929L17.5858 12L16.2929 10.7071C15.9024 10.3166 15.9024 9.68343 16.2929 9.29291Z" fill="white"></path>
                </svg>
            `;
        }
    }

    navigateImage(direction) {
        if (!this.imageOverlay.classList.contains('active')) return;

        const project = this.projectsData[this.currentOverlayProject];
        const imagesToUse = project.allImages || project.drawerImages;
        let newIndex = this.currentOverlayImage + direction;

        // Handle looping: if going past last image, go to first; if going before first, go to last
        if (newIndex >= imagesToUse.length) {
            newIndex = 0; // Loop to first image
        } else if (newIndex < 0) {
            newIndex = imagesToUse.length - 1; // Loop to last image
        }

        this.currentOverlayImage = newIndex;
        const mediaSrc = imagesToUse[newIndex];

        // Determine if this is a video or image
        const isVideo = mediaSrc.endsWith('.mp4') || mediaSrc.endsWith('.webm') || mediaSrc.endsWith('.mov');

        if (isVideo) {
            // Hide image, show video
            this.overlayImage.style.display = 'none';
            this.overlayVideo.style.display = 'block';
            this.overlayVideo.src = mediaSrc;
            this.overlayVideo.load(); // Reload the video

            // Auto-play the video
            this.overlayVideo.play().catch(e => console.log('Video autoplay failed:', e));
        } else {
            // Hide video, show image
            this.overlayVideo.style.display = 'none';
            this.overlayImage.style.display = 'block';
            this.overlayImage.src = mediaSrc;
        }

        const altText = `${project.title} - ${isVideo ? 'Video' : 'Image'} ${newIndex + 1}`;
        this.overlayImage.alt = altText;

        this.updateNavigationButtons();
        this.updateImageCounter();
    }

    updateNavigationButtons() {
        const project = this.projectsData[this.currentOverlayProject];
        const imagesToUse = project.allImages || project.drawerImages;

        // With looping enabled, buttons are never disabled (except for single image)
        this.prevButton.classList.remove('disabled');
        this.nextButton.classList.remove('disabled');

        // Hide buttons if there's only one image
        if (imagesToUse.length <= 1) {
            this.prevButton.style.display = 'none';
            this.nextButton.style.display = 'none';
        } else {
            this.prevButton.style.display = 'flex';
            this.nextButton.style.display = 'flex';
        }
    }

    closeImageOverlay() {
        // Pause and reset any playing video
        if (this.overlayVideo && !this.overlayVideo.paused) {
            this.overlayVideo.pause();
            this.overlayVideo.currentTime = 0;
        }

        this.imageOverlay.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
    }

    closeDrawer(projectIndex) {
        const drawer = this.projectDrawers[projectIndex];
        if (drawer) {
            // Add closing class for faster animation
            drawer.classList.add('closing');
            drawer.classList.remove('open');

            if (this.openDrawer === projectIndex) {
                this.openDrawer = null;
            }

            // Remove closing class after animation completes
            setTimeout(() => {
                drawer.classList.remove('closing');
            }, 250); // Wait for fast closing animation to complete

            // Refresh ScrollTrigger after drawer closes to recalculate positions
            this.refreshScrollTriggerAfterDelay();
        }
    }

    refreshScrollTriggerAfterDelay() {
        // Wait for CSS transition to complete before refreshing ScrollTrigger
        // Using shorter delay for fast closing animation
        setTimeout(() => {
            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 300); // Adjusted for faster closing animation
    }

    closeAllDrawers() {
        this.projectDrawers.forEach((drawer, index) => {
            if (drawer.classList.contains('open')) {
                // Add closing class for faster animation
                drawer.classList.add('closing');
                drawer.classList.remove('open');

                // Remove closing class after animation completes
                setTimeout(() => {
                    drawer.classList.remove('closing');
                }, 250); // Wait for fast closing animation to complete
            }
        });
        this.openDrawer = null;

        // Refresh ScrollTrigger after closing all drawers
        this.refreshScrollTriggerAfterDelay();
    }

    updateProjectActiveState(activeIndex) {
        this.projectItems.forEach((item, index) => {
            if (index === activeIndex) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }
}
